import { render, staticRenderFns } from "./ReviewStampedDocumentPoInstructions.vue?vue&type=template&id=03045649"
import script from "./ReviewStampedDocumentPoInstructions.vue?vue&type=script&lang=ts"
export * from "./ReviewStampedDocumentPoInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports